import {
  collection,
  doc,
  getDocs,
  limit,
  orderBy,
  query,
  updateDoc,
  where,
} from 'firebase/firestore';
import { db } from '../firebase';

export interface ActivityRow {
  id: string;
  candidatureId?: string;
  status?: string;
  date?: Date;
  hours?: number;
  description?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

const COLLECTION = 'activities';

export async function listActivities(options?: {
  status?: string;
  limitCount?: number;
}): Promise<ActivityRow[]> {
  const clauses: any[] = [];
  if (options?.status) {
    clauses.push(where('status', '==', options.status));
  }
  clauses.push(orderBy('date', 'desc'));
  if (options?.limitCount) {
    clauses.push(limit(options.limitCount));
  }

  const snap = await getDocs(
    query(collection(db, COLLECTION), ...clauses)
  );

  return snap.docs.map((d) => {
    const data = d.data() as any;
    return {
      id: d.id,
      candidatureId: data.candidatureId,
      status: data.status,
      date: data.date?.toDate ? data.date.toDate() : undefined,
      hours:
        typeof data.hours === 'number'
          ? data.hours
          : typeof data.hours === 'string'
          ? Number(data.hours)
          : undefined,
      description: data.description,
      createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : undefined,
      updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : undefined,
    };
  });
}

export async function updateActivityStatus(
  id: string,
  status: 'validated' | 'rejected' | 'pending'
): Promise<void> {
  const ref = doc(db, COLLECTION, id);
  await updateDoc(ref, { status });
}

